export default function CustomTabs({ tabs, activeTab, onTabChange, maxHeight = false }) {
  return (
    <div className="w-full">
      {/* Tab Buttons */}
      <div className="flex flex-wrap justify-center gap-2 mb-6 border-b pb-2">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`px-2 py-2 rounded-md font-medium text-sm transition-colors ${
              activeTab === tab.key
                ? "bg-[var(--button-bg-color)] text-[var(--text-color)] border border-[var(--outline2-color)] shadow"
                : "bg-[var(--button2-bg-color)] text-[var(--text6-color)] hover:bg-[var(--button-bg-color)] hover:text-[var(--text-color)] shadow"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div
        className={`rounded-xl bg-[var(--entity-bg-color)] p-2 sm:p-3`}
      >
        {tabs.find((t) => t.key === activeTab)?.component}
      </div>
    </div>
  );
}
